import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/user-empty.svg'
import _imports_1 from '@/assets/images/point-active.svg'


const _withScopeId = n => (_pushScopeId("data-v-59becc87"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "" }
const _hoisted_2 = {
  key: 0,
  class: "bg-white shadow rounded-4 mt-4 mb-3 p-xl-4 p-3"
}
const _hoisted_3 = { class: "user-container d-flex flex-column justify-content-center align-items-center" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "user"
}, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "fw-bold fs-4 text-center" }, "麦山 純雄", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "text-center" }, "ムギチャ", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "bg-gray p-3 mb-3" }, [
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("div", { class: "d-flex justify-content-center align-items-center" }, [
      /*#__PURE__*/_createElementVNode("img", {
        src: _imports_1,
        alt: "point"
      }),
      /*#__PURE__*/_createElementVNode("p", { class: "mb-0" }, "保有YELLポイント")
    ]),
    /*#__PURE__*/_createElementVNode("p", { class: "text-center mb-0" }, [
      /*#__PURE__*/_createElementVNode("b", { class: "fs-5" }, "1500"),
      /*#__PURE__*/_createTextVNode(),
      /*#__PURE__*/_createElementVNode("span", { class: "fs-7" }, "pt")
    ])
  ])
], -1))
const _hoisted_8 = { class: "d-flex justify-content-center flex-column" }

import UserAliasIcon from '@/components/user-alias-icon/index.vue'
import Button from '@/components/button/index.vue'
import Menu from '@/components/layouts/aside-admin/Menu.vue'
import UserMenu from '@/components/header/user-menu-admin/index.vue'

import { computed } from 'vue-demi'
import { ROOT_STORE } from '@/store/constants'
import { useStore } from 'vuex'

export default /*#__PURE__*/_defineComponent({
  props: {
  showTags: {
    type: Boolean,
    default: true,
  },
  showUser: {
    type: Boolean,
    default: false,
  },
  showGroup: {
    type: Boolean,
    default: false,
  },
},
  setup(__props) {

// import HashTag from '@/components/hash-tag/index.vue'
const store = useStore()
const isMobile = computed<boolean>(() => store?.getters[ROOT_STORE.GETTERS.CHECK_MOBILE_DEVICE])



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("aside", _hoisted_1, [
    (__props.showUser)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _hoisted_4,
            _createVNode(UserAliasIcon),
            _hoisted_5,
            _hoisted_6
          ]),
          _hoisted_7,
          _createElementVNode("div", _hoisted_8, [
            _createVNode(Button, {
              title: 'プロフィール設定',
              type: 'secondary',
              "class-name": "mb-3"
            }),
            _createVNode(Button, {
              title: 'ポートフォリオ設定',
              type: 'secondary'
            })
          ])
        ]))
      : _createCommentVNode("", true),
    (!_unref(isMobile))
      ? (_openBlock(), _createBlock(Menu, { key: 1 }))
      : _createCommentVNode("", true)
  ]))
}
}

})